
import {
    GET_OPEN_JOBS, GET_OPEN_JOBS_SUCCESS, GET_OPEN_JOBS_FAILURE
} from './actionTypes';

const initialState = {
    loader: false,
    openJobs: [],
    queryParameters: {},
    openJobsErrorMessage: null
}

const openJobsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OPEN_JOBS:
            state = {
                ...state,
                loader: true,
                openJobs: [],
                queryParameters: action.payload,
                openJobsErrorMessage: null
            }
            break
        case GET_OPEN_JOBS_SUCCESS:
            state = {
                ...state,
                loader: false,
                openJobs: action.payload
            }
            break
        case GET_OPEN_JOBS_FAILURE:
            state = {
                ...state,
                loader: false,
                openJobs: [],
                openJobsErrorMessage: action.payload.viewJob
            }
            break
        default:
            state = { ...state }
            break
    }
    return state
}

export default openJobsReducer
